import _ from 'underscore';
import { createSelector } from 'reselect';
import scheduledMeetingsSelector from './scheduled_meetings_selector';
import teachersSelector from './teachers_selector';
import availableStaffSelector from './available_staff_selector';
import studentCohortCardSelector from './student_cohort_card_selector';
import inspectorCards from './inspector_cards';

const inspectorSelector = createSelector(
  state => scheduledMeetingsSelector.getInspected(state),
  state => teachersSelector.getInspected(state), 
  state => availableStaffSelector(state),
  state => studentCohortCardSelector(state),
  state => state.schedules,
  
  (inspectedMeetings, inspectedTeachers, availableStaff, studentCohort, schedules) => {
    let cardsData = {
      meetings: inspectedMeetings,
      teachers: _.uniq(inspectedTeachers),
      available_staff: _.uniq(availableStaff),
      studentCohort: studentCohort
    };

    return {
      schedules: schedules,
      cards: inspectorCards(cardsData),
      showCards: (
        cardsData.meetings.length > 0 || 
        cardsData.teachers.length > 0
      )
    };
  }
);

export default inspectorSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/inspector_selector.js
 **/